import { ObjectNames } from './../../modules/shared/constants/object.names';
import { PermissionService } from './../../service/permission.service';
import { LocalDatePipe } from './../../modules/shared/pipes/local-date.pipe';
import { WorkflowMessages } from './models/workflow.static';
import { AppMainService } from './../../app-main.service';
import { WorkflowService } from './services/workflow.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppMainComponent } from '../../app.main.component';
import { UserService } from '../../service/userservice';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { SavedSearchNS } from '../saved-searches/models/saved-search.models';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { WorkflowModelsNS } from './models/add-update-workflow.models';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-workflow',
    templateUrl: './workflow.component.html',
    styleUrls: ['./workflow.component.scss'],
    providers: [LocalDatePipe]
})
export class WorkflowComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    menuItems: any[] = [];
    configMenuItemsCM: any[] = [];

    isActive: boolean = true;
    selectedRecent;
    selectedView: 'split'|'list' = "list";
    selectedWorkflow;
    selectedWorkflowBlock: any;
    workflowExecutionStatus = WorkflowModelsNS.WorkflowExecutionStatus;
    workflowOccurrenceTypes = WorkflowModelsNS.WorkflowOccurrenceTypsEnum;
    //List
    searchControl = new FormControl();
    moduleSearchValue = '';
    gridState: any = {};

    workflowListResults: any[] = [];
    noWfFindOrLoadingText = 'No Workflow Found.';
    pageNumber: number = 1;
    pageSize: number = 15;
    totalRecords: number = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;

    displayNewWorkflow: boolean = false;
    workflowCopy: boolean = false;
    workflowViewOnly: boolean = false;
    workflowEditId: number = 0;

    //Static Data
    recentItems = [
        { name: "All Workflow", code: 'allworkflow' },
        { name: 'My Workflow', code: 'myworkflow' },
        { name: 'New This week', code: 'newthisweek' },
        { name: 'New Last week', code: 'newlastweek' },
        { name: 'New This month', code: 'newthismonth' },
        { name: 'Recently Viewed Workflow', code: 'recentlyviewedworkflow' }
    ];

    listCols1: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: true, moveable: false, dataType: 'number' },
        { field: 'name', header: 'Name', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' }
    ];
    listCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: true, moveable: false, dataType: 'number' },
        { field: 'sequenceNumber', header: 'Id. No.', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'name', header: 'Name', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'objectName', header: 'Module Name', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'channelName', header: 'Channel Name', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'workflowType', header: 'Workflow Type', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'triggerOn', header: 'Criteria', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'createdDate', header: 'Created Date', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'date' },
        { field: 'createdBy', header: 'Created By', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'lastUpdated', header: 'Last Updated Date', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'date' },
        { field: 'lastUpdatedBy', header: 'Last Updated By', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'conditions', header: 'Conditions', show: false, value: '', checked: false, order: false,  moveable: false, dataType: 'string' },
        { field: 'actions', header: 'Actions', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'executionStatus', header: 'Execution Status',show: false, value: '', checked: false, order: false, moveable: false, dataType: 'string' }
    ];
    listColsAll: SavedSearchNS.IColumn[] = ParseHelper.DeepCopy(this.listCols);

    /* Permission */
    readPermission: boolean;
    writePermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    exportPermission: boolean;

    fromQuery: boolean = false;
    globalSearchData: any = null;

    constructor(
        private localDatePipe: LocalDatePipe,
        private appMainService: AppMainService,
        private userService: UserService,
        public app: AppMainComponent,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private workflowService: WorkflowService,
        private permissionService: PermissionService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        this.setPermissions();
        this.tableGlobalSearchInit();
        this.subscribeToQueryParams();
    }

    // Set permissions for read, write, edit, delete and export
    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();

        if (userPermissions.length) {
            const userPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WORKFLOW);

            const modulePermission = userPermission ? userPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1) : null;

            this.readPermission = modulePermission && (modulePermission[0].permissionId == 1 && modulePermission[0].statusId == 1);
            this.writePermission = modulePermission && (modulePermission[1].permissionId == 2 && modulePermission[1].statusId == 1);
            this.editPermission = modulePermission && (modulePermission[2].permissionId == 3 && modulePermission[2].statusId == 1);
            this.deletePermission = modulePermission && (modulePermission[3].permissionId == 4 && modulePermission[3].statusId == 1);
            this.exportPermission = modulePermission && (modulePermission[4].permissionId == 5 && modulePermission[4].statusId == 1);
        }

        this.buildContextMenu();
    }
  
    buildContextMenu(){
        this.configMenuItemsCM = [];

        let visible: boolean = !!(this.selectedWorkflow?.executionStatus==this.workflowExecutionStatus[this.workflowExecutionStatus.Pending] || !this.selectedWorkflow?.jobId);

        this.configMenuItemsCM.push(
            {
                label: 'View',
                icon: 'pi pi-list',
                command: () => {
                    this.showEditWorkflow('View');
                }
            },
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                visible: this.editPermission,
                disabled: !visible,
                command: () => {
                    this.showEditWorkflow('Edit');
                }
            },
            {
                label: 'Make Copy',
                icon: 'pi pi-copy',
                visible: this.editPermission,
                command: () => {
                    this.showEditWorkflow('Copy');
                }
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                visible: this.deletePermission,
                disabled: !visible,
                command: () => {
                    this.deleteSavedSearch(this.selectedWorkflow);
                }
            },
        );
        this.menuItems = [];
        this.menuItems.push(
            {
                label: 'New',
                icon: 'pi pi-plus',
                visible: this.writePermission,
                command: (event) => this.showAddWorkflow(),
            },
            // {
            //     label: 'Settings',
            //     icon: 'pi pi-cog ',
            //     command: (event) => this.settings()
            // }
        );
    }

    tableGlobalSearchInit(){
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.moduleSearchValue = value.trim() ? value.trim() : '';
                this.onGlobalSearch();
            });
    }

    onGlobalSearch() {
        this.resetWorkflowPagination();
        this.getAllWorkflowList(1, 15);
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    getWorkflowListByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getAllWorkflowList(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        this.pageSize = event.rows;
        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getAllWorkflowList(pageNumber, pageSize);
    }

    getAllWorkflowList(pageNumber: number, pageSize: number){

        this.pageNumber = pageNumber;
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            let searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        options.moduleSearchValue = this.moduleSearchValue.length ? this.moduleSearchValue.trim() : '';
        this.appMainService.isShowSpinner('getWorkflowList');
        this.workflowService.getAlWorkflowList(pageNumber, pageSize, this.isActive, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) =>{
                this.appMainService.isHideSpinner('getWorkflowList');

                let data = response.body == null ? [] : response.body;
                let headers = JSON.parse(response.headers.get('X-Pagination'));
                headers = headers == null ? [] : headers;
                this.totalRecords = headers['TotalCount'] || 0;

                this.workflowListResults = data.map(workflowDetails=>{

                    let workflowCriteria = workflowDetails.triggerOn;

                    if((workflowDetails?.triggerType==4 && workflowDetails?.occurrenceBase)){
                        if(workflowDetails?.occurrenceType==WorkflowModelsNS.WorkflowScheduleTypesEnum.Once){
                            workflowCriteria = 'Workflow will run Once';
                        }else{
                            workflowCriteria = `Workflow run every ${ workflowDetails?.occurrenceValue } ${ this.workflowOccurrenceTypes[workflowDetails.occurrenceBase] }`;
                        }
                    }

                    return {
                        ...workflowDetails,
                        workflowType: workflowDetails?.triggerType==4? 'Time Based' : 'Event Based',
                        triggerOn: workflowCriteria
                    }
                });

                if(this.selectedView=='split' && this.selectedWorkflow){
                    this.selectedWorkflow = this.workflowListResults.find(w=>w.id==this.selectedWorkflow?.id)||this.selectedWorkflow;
                    this.onRowSelect(null);
                }
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getWorkflowList');
            }
        })
    }

    resetWorkflowPagination() {
        this.first = 0;
    }

    loadListingWithFilters(): void {
        this.first = 0;
        this.listView();
        this.getAllWorkflowList(1, this.pageSize);
    }

    listView(){
        this.selectedWorkflow = null;
        this.listCols = this.listColsAll;
        this.selectedView = 'list';
        this.fromQuery = false;
    }

    backListView() {
        this.listView();
        this.resetWorkflowPagination();
        this.getAllWorkflowList(1, this.pageSize);
    }

    showEditWorkflow(addEditType: 'Copy'|'View'|'Edit'){
        if(this.selectedWorkflow?.id>0){
            this.workflowEditId = this.selectedWorkflow.id;
            this.workflowViewOnly = (addEditType=='View') as boolean;
            this.workflowCopy = (addEditType=='Copy') as boolean;
            this.displayNewWorkflow = true;
        }
    }

    showAddWorkflow() {
        this.workflowEditId = 0;
        this.displayNewWorkflow = true;
        this.workflowCopy = false;
        this.workflowViewOnly = false;
    }
    cancelWorkflow() {
        this.workflowViewOnly = false;
        this.workflowEditId = 0;
        this.workflowCopy = false;
        this.displayNewWorkflow = false;
    }

    loadNewList(load: boolean){
        if(load){
            this.resetWorkflowPagination();
            this.getAllWorkflowList(1,this.pageSize);
        }
    }

    loadCurrentPage(){
        this.getAllWorkflowList(this.pageNumber,this.pageSize);
    }


    settings() {

    }
    recentUpdate() {

    }

    viewWorkflow() {

    }

    onRowSelect(event) {
        this.listCols = this.listCols1;
        this.selectedView='split';

        this.selectedWorkflowBlock = {
            ...this.selectedWorkflow,
            lastUpdated: this.selectedWorkflow?.lastUpdated ? this.localDatePipe.transform(this.selectedWorkflow.lastUpdated) : null,
            createdDate: this.selectedWorkflow?.createdDate ? this.localDatePipe.transform(this.selectedWorkflow.createdDate) : null
        }
    }

    onRowUnselect(event){
        this.selectedWorkflow = null;
        this.listCols = this.listColsAll;
        this.selectedView='list'
    }

    //*Delete workflow
    deleteSavedSearch(workflow: any) {
        this.confirmationService.confirm({
            message: WorkflowMessages.deleteconfirmationMessage,
            header: WorkflowMessages.deleteHeader,
            icon: WorkflowMessages.deleteCircleIcon,
            accept: () => {
                this.appMainService.isShowSpinner('deleteWorkflow')
                this.workflowService.deleteWorkflow(workflow.id)
                    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
                        this.appMainService.isHideSpinner('deleteWorkflow')
                        this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.deleteSuccessMsg });
                        this.backListView();
                    },
                        err => {
                            this.appMainService.isHideSpinner('deleteWorkflow')
                        });
            },
            reject: () => {
            }
        });
    }
    
    /**
     * Subscribes to query parameters 
     * and perform actions based on the received parameters.
     */

    subscribeToQueryParams(): void {
        this.route.queryParams.subscribe((params) => {
            if (params && params.id && params.data) {
                this.fromQuery = true;
                this.selectedWorkflow = {id: params.id};
                this.globalSearchData = [{id: params.id, name: params.data}];
                this.onRowSelect(null);
            }
        });
    } 

    refreshList(event): void {
        this.fromQuery = false;
        this.backListView();
    }

    /**
     * End Subscribe to query params
     */

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }


}
